import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export class statuslist{
  constructor(){}

  public statusId : number;
  public status : string;
  public type : string;
  public odds : string;
}

@Injectable({
  providedIn: 'root'
})

export class StatusService {

  constructor(private httpClient:HttpClient) { }

  /**
   * getsectorsList
  */
  public getstatusList() {
    return this.httpClient.get<statuslist[]>('api/v1/status/');
  }
  
  public createStatus(obj : any) : Observable<any>{
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.post<any>('/api/v1/status/' , obj , {headers}).pipe(catchError(this.errorHandler));
  }

  updateStatus(bean: any): Observable<any> {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.put<any>('/api/v1/status/' , bean , {headers}).pipe(catchError(this.errorHandler));
  }

  public deleteStatus(Id: number){
    return this.httpClient.delete('api/v1/status/' + Id);
  }

  
  errorHandler(error: HttpErrorResponse){
    console.log(error.message);
    return throwError(error.message || 'Server Error');
  }

}
